import { X } from "lucide-react";
import { useEffect } from "react";
import { copy } from "../copy";
import { useApp } from "../state/store";
import { FindForm } from "../views/Find";

export function FindDrawer() {
  const app = useApp();
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") app.navigate("today");
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [app]);

  return (
    <div className="drawer-backdrop" onMouseDown={() => app.navigate("today")}>
      <div className="drawer" role="dialog" aria-modal="true" aria-label={copy.home.find} onMouseDown={(event) => event.stopPropagation()}>
        <header>
          <h2>{copy.home.find}</h2>
          <button type="button" onClick={() => app.navigate("today")} aria-label={copy.close}>
            <X size={16} />
          </button>
        </header>
        <div className="drawer-body">
          <FindForm intent="task" onDone={() => app.navigate("inbox", "tab=find")} />
        </div>
      </div>
    </div>
  );
}
